export default __webpack_public_path__ + "static/media/higher_frame_logo_copy.a88cac2c.svg";